<template>
  <div class="box" :class="classN">
    <input @change="change($event)" :name="item" :id="'box_' + item.trim()" class="check" type="checkbox" :checked="$attrs.data ? 'checked' : '' " />
    <label class="label" :for="'box_' + item">
      <svg class="ico">
        <use :xlink:href="icon"></use>
      </svg>
      {{ item }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
      item: String,
      classN: String,
      icon: String,
      track: Function
  },
  methods: {
    change: function(event) {
      this.$emit('track', this.$props.item + "_filter_change");
      this.$emit('update:data', event.target.checked ? true :false)
    }

  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.box {
  position: relative;
  float: left;
  margin: 0 .625rem .625rem 0;

  &:focus-within {
    box-shadow: 0 .625rem .625rem $col_aqua;
  }
}

.check {
  display: none;

  &:checked + label {
    border-color: $col_aqua;
    background: $col_white;

    &:before {
      background-color: $col_aqua;
      border-color: $col_aqua;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0' y='0' width='78.369px' height='78.369px' viewBox='0 0 78.369 78.369' enable-background='new 0 0 78.369 78.369' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='%23FFFFFF' d='M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015 c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113 c0.43-0.427,1.12-0.427,1.549,0l6.702,6.704C78.478,17.894,78.478,18.586,78.049,19.015z'/%3E%3C/g%3E%3C/svg%3E%0A");
      background-position: 50% 50%;
      background-size: 0.625rem;
      background-repeat: no-repeat;
    }
  }
}

.ico {
  width: 1.25rem;
  position: absolute;
  height: 1.25rem;
  top: 50%;
  margin-top: -0.625rem;
  left: .938rem;
}

.label {
  width: auto;
  height: 2.188rem;
  line-height: 2.188rem;
  box-sizing: border-box;
  font-size: .688rem;
  font-weight: 700;
  position: relative;
  text-transform: uppercase;
  background-color: #FAFAFA;
  border: 0.0625rem solid #DEDEDE;
  display: block;
  border-radius: .188rem;
  padding: 0 2.5rem;

  &, &:before {
    transition: all 0.2s ease-in-out;
  }

  svg {
    left: .625rem;
    width: 1.25rem;
    position: absolute;
    height: 1.25rem;
    top: 50%;
    margin-top: -0.625rem;
  }

  &:before {
    content: "";
    border-radius: 100%;
    border: .0625rem solid white;
    background-color: #EEEEEE;
    box-sizing: border-box;
    right: .625rem;
    width: 1.25rem;
    position: absolute;
    height: 1.25rem;
    top: 50%;
    margin-top: -0.625rem;
  }
}

@media #{$xs-phone} {
  svg {
    display: none;
  }

  .label {
    padding: 0 2rem 0 0.5rem;
  }
}

</style>